import { signOutUser } from '../utils/auth/signOutUser';
import { useLocationStore } from '../stores/locationStore';
import { useContext } from 'react';
import { UserContext } from './UserContext';
import { UserContextType } from '../@types/user';

export const useSignout = () => {
  const { activeLocation } = useLocationStore();
  const { userState } = useContext(UserContext) as UserContextType;

  const handleLogout = async (delayTime?: number): Promise<void> => {
    // Calculate analytics data if session exists
    const analytics = userState.sessionStart
      ? (() => {
          const sessionEnd = new Date().valueOf();
          const timeDiffInSeconds =
            (sessionEnd - userState.sessionStart) / 1000;
          const minutes = Math.floor(timeDiffInSeconds / 60);
          const seconds = Math.floor(timeDiffInSeconds % 60);
          return {
            locationNum: activeLocation,
            sessionLength: `${minutes} minutes ${seconds} seconds`,
          };
        })()
      : undefined;

    // Use centralized sign-out utility
    await signOutUser({
      analytics,
      delayMs: delayTime,
      reason: 'user-initiated',
    });
  };

  return { handleLogout };
};
